<div class="modal-open"
     *ngIf="open">

  <div class="modal-backdrop fade in"></div>

  <div class="modal fade in display-block"
       role="dialog">

    <form [formGroup]="form"
          (submit)="submit()">

      <div class="modal-dialog"
           role="document">

        <div class="modal-content">

          <div class="modal-header mb-0">

            <h5 class="modal-title">{{ localisation.title }}</h5>

            <button type="button"
                    class="close"
                    title="{{ localisation.closeLabel }}"
                    data-dismiss="modal"
                    onclick="this.blur()"
                    (click)="cancel()">
              <i class="fa-regular fa-xmark"></i>
            </button>

          </div>

          <div class="modal-filters">
            <div class="form-inline">

              <div class="form-group pl-0 search-term-label">
                <label for="searchTerm">{{ localisation.searchLabel }}</label>
              </div>

              <div class="form-group pl-0 search-term">

                <input id="searchTerm"
                       type="text"
                       class="form-control"
                       [formControl]="controls.searchTerm"
                       [placeholder]="localisation.searchPlaceholder || ''">

              </div>

              <div class="form-group col-xs-5 category">
                <ng-container *ngIf="categoryFilter">

                  <select id="categoryFilter"
                          class="form-control"
                          [formControl]="controls.category">

                    <option value="">{{ localisation.allCategoriesLabel }}</option>

                    <ng-container *ngFor="let group of categoryFilter.groups | async">

                      <ng-container *ngIf="!!group.label else options">
                        <optgroup [label]="group.label">
                          <ng-container [ngTemplateOutlet]="options"></ng-container>
                        </optgroup>
                      </ng-container>

                      <ng-template #options>
                        <ng-container *ngFor="let category of group.categories; trackBy: trackById">
                          <option [ngValue]="category">{{ category.label }}</option>
                        </ng-container>
                      </ng-template>

                    </ng-container>

                  </select>

                </ng-container>
              </div>

              <div class="form-group pr-md text-right">

                <ng-container *ngIf="!singular">

                  <span class="btn btn-tertiary button-select-all"
                        onclick="this.blur()"
                        [ngClass]="!!viewableDataset.length ? 'btn-tertiary' : 'btn-tertiary-disabled'"
                        (click)="selectAll()">
                    {{ localisation.selectAllLabel }}
                  </span>

                  <span class="btn btn-tertiary button-select-none"
                        onclick="this.blur()"
                        [ngClass]="!!viewableDataset.length ? 'btn-tertiary' : 'btn-tertiary-disabled'"
                        (click)="selectNone()">
                    {{ localisation.selectNoneLabel }}
                  </span>

                </ng-container>

              </div>

            </div>
          </div>

          <div class="modal-body spinner" *ngIf="!initialized || loading">
            <div class="col-md-12 text-center">
              <p><i class="far fa-spinner fa-spin p-10"></i></p>
            </div>
          </div>

          <div class="modal-body none-selectable" *ngIf="initialized && !loading && !viewableDataset.length">
            <div class="col-md-12 text-center">

              <ng-container *ngIf="!openingDataset?.length">
                <p class="no-data">{{ localisation.noDataText }}</p>
              </ng-container>

              <ng-container *ngIf="!!openingDataset?.length">
                <p class="no-matches">{{ localisation.noMatchesText }}</p>
              </ng-container>

            </div>
          </div>

          <div class="modal-body some-selectable" *ngIf="initialized && !loading && !!viewableDataset.length">

            <div class="scrollbar-spacer">
              <div class="scrollbar-spacer-content">
                <table class="table">
                  <thead>
                  <tr>

                    <ng-container *ngIf="columnExtractor else defaultColumnHeading">
                      <ng-container *ngFor="let column of columnExtractor.columns; let index = index">

                        <th [class]="('column-' + index + ' ' + (column.headingClass || ''))"
                            [style]="column.headingStyle">
                          {{ column.headingLabel }}
                        </th>

                      </ng-container>
                    </ng-container>

                    <ng-template #defaultColumnHeading>
                      <th class="data-item">{{ localisation.itemHeaderLabel }}</th>
                    </ng-template>

                    <th class="data-selector">{{ localisation.selectHeaderLabel }}</th>

                  </tr>
                  </thead>
                </table>
              </div>
              <div class="scrollbar-spacer-space">
                <div class="scrollbar-spacer-adjuster"></div>
              </div>
            </div>

            <cdk-virtual-scroll-viewport class="selectable-scroll-viewport" itemSize="50">

              <div class="table-responsive mb-0">
                <table class="table">
                  <tbody>

                  <ng-container *ngIf="virtual">

                    <ng-container *cdkVirtualFor="let data of viewableDataset; trackBy: trackById">
                      <ng-container [ngTemplateOutlet]="row"
                                    [ngTemplateOutletContext]="{ data: data }">
                      </ng-container>
                    </ng-container>

                  </ng-container>

                  <ng-container *ngIf="!virtual">

                    <ng-container *ngFor="let data of viewableDataset; trackBy: trackById">
                      <ng-container [ngTemplateOutlet]="row"
                                    [ngTemplateOutletContext]="{ data: data }">
                      </ng-container>
                    </ng-container>

                  </ng-container>

                  </tbody>
                </table>
              </div>

            </cdk-virtual-scroll-viewport>

            <ng-template #row let-data='data'>

              <tr [id]="('row-' + data.id)">

                <ng-container *ngIf="columnExtractor else defaultColumnValue">
                  <ng-container *ngFor="let column of columnExtractor.columns; let index = index">

                    <td [class]="('column-' + index + ' ' + (column.valueClass || ''))"
                        [style]="column.valueStyle"
                        (click)="toggleOne(data)">
                      <label class="pl-0"
                             [for]="('data-' + data.id)"
                             (click)="$event.stopPropagation()">{{ columnExtractor.getValue(index, data) | async }}</label>
                    </td>

                  </ng-container>
                </ng-container>

                <ng-template #defaultColumnValue>

                  <td class="column-0 data-item"
                      (click)="toggleOne(data)">
                    <label class="pl-0"
                           [for]="('data-' + data.id)"
                           (click)="$event.stopPropagation()">{{ data.label }}</label>
                  </td>

                </ng-template>

                <td class="data-selector"
                    (click)="toggleOne(data)">
                  <input [type]="singular ? 'radio': 'checkbox'"
                         class="form-control"
                         name="data-selector"
                         [id]="('data-' + data.id)"
                         [checked]="data.selected"
                         (click)="$event.stopPropagation()"
                         (change)="toggleOne(data)">
                </td>

              </tr>

            </ng-template>

          </div>

          <div class="modal-footer">

            <div class="pull-left">

              <button type="button"
                      class="btn button-selected"
                      onclick="this.blur()"
                      [ngClass]="{
                        'btn-filter': !this.selectionFilterActive,
                        'btn-selected': this.selectionFilterActive
                      }"
                      [ngPlural]="selectedCount.value"
                      (click)="toggleSelectionFilter()">

                <ng-template ngPluralCase="=0">

                  <ng-container [ngTemplateOutlet]="zeroSelectedTemplate"
                                [ngTemplateOutletContext]="{ selectedCount: selectedCount.value }">
                  </ng-container>

                </ng-template>

                <ng-template ngPluralCase="=1">

                  <ng-container [ngTemplateOutlet]="oneSelectedTemplate"
                                [ngTemplateOutletContext]="{ selectedCount: selectedCount.value }">
                  </ng-container>

                </ng-template>

                <ng-template ngPluralCase="other">

                  <ng-container [ngTemplateOutlet]="manySelectedTemplate"
                                [ngTemplateOutletContext]="{ selectedCount: selectedCount.value }">
                  </ng-container>

                </ng-template>

              </button>

            </div>

            <button type="button"
                    class="btn btn-secondary button-cancel"
                    onclick="this.blur()"
                    (click)="cancel()">
              {{ localisation.cancelLabel }}
            </button>

            <button type="button"
                    class="btn btn-default button-select"
                    onclick="this.blur()"
                    [disabled]="required && !selectedCount.value"
                    (click)="submit()">
              {{ localisation.submitLabel }}
            </button>

          </div>

        </div>

      </div>

    </form>

  </div>

</div>
